// extracted by mini-css-extract-plugin
export default {"container":"CardV3_container__h3IQw","card":"CardV3_card__eXfEg"};